import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
  FormHelperText,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages } from "src/constant/Messages";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Skeleton from "@material-ui/lab/Skeleton";
import { addNameFieldForKey } from "src/utils/utils";
import { kmLabels } from "src/constant/Texts";
import { fillMissingTags } from "src/utils/utils";

const nameMaxLength = 100;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  validate: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}${nameMaxLength}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const Form = ({
  onSubmit,
  permissions,
  userProfile,
  editMode,
  areDictsLoaded,
  ...rest
}) => {
  const classes = useStyles();
  const [defaultPermissions, setDefaultPermissions] = useState([]);

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {
    if (editMode) {
      if (userProfile && userProfile.name && userProfile.profilePermissions){
        setValue("name", userProfile.name);
        setValue("permissions", userProfile.profilePermissions);
        let processedPermissions = addNameFieldForKey(userProfile.profilePermissions,kmLabels.user_permissions);
        setDefaultPermissions(processedPermissions);
      }
    }
    return () => {};
  }, [userProfile, areDictsLoaded, permissions]);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Grid container className={classes.root}>
            <Grid item xs={12} elevation={2}>
              {areDictsLoaded ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <FormControl
                    fullWidth
                    className={classes.formcontrol}
                  >
                    <Controller
                      as={
                        <TextField
                          error={errors.name ? true : false}
                          id="name"
                          name="name"
                          label="Nazwa"
                          placeholder="Nazwa"
                          multiline
                          helperText={
                            errors.name &&
                            (formValidation[errors.name.type] || "")
                          }
                        />
                      }
                      name="name"
                      defaultValue=""
                      control={control}
                      rules={{ required: true, maxLength: nameMaxLength }}
                    />
                  </FormControl>
                  {permissions && permissions.length > 0 ? (
                    
                    <Controller
                      render={({ onChange, ...props }) => (
                        <Autocomplete
                          multiple
                          id="permissions"
                          options={permissions}
                          getOptionLabel={(option) => option.name}
                          getOptionSelected={(option, value) =>
                            value && option.key === value.key
                          }
                          value={props.value}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={errors.permissions ? true : false}
                              label="Uprawnienia"
                              placeholder="Uprawnienia"
                             
                              helperText={
                                errors.permissions &&
                                (formValidation[errors.permissions.type] ||
                                  "")
                              }
                            />
                          )}
                          onChange={(e, data) => onChange(data)}
                        />
                      )}
                      onChange={([, data]) => data}
                      name="permissions"
                      control={control}
                      rules={{ required: true, validate: value => value.length > 0 }}
                      defaultValue={defaultPermissions}
                    />
                  ) : (
                    <Skeleton />
                  )}
                  <Box className={classes.paddingtop}>
                    <Button
                      color="primary"
                      className={classes.button}
                      component={RouterLink}
                      to="/profile"
                    >
                      Anuluj
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.button}
                      endIcon={<SaveIcon />}
                      type="submit"
                    >
                      Zapisz
                    </Button>
                  </Box>
                </form>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Box>
    </Card>
  );
};

export default Form;
